<template>
  <div>
    <select v-model="selectedCountry" :class="classes.input" @change="emitValue($event.target.value)">
      <option value="" disabled>{{ props.context.node.props.attrs.placeholder || 'Selecciona tu país' }}</option>
      <optgroup label="Latinoamérica y España">
        <option v-for="(name, code) in sortedLatamCountries" :key="code" :value="name">
          {{ name }}
        </option>
      </optgroup>
      <optgroup label="Resto del Mundo">
        <option v-for="(name, code) in sortedOtherCountries" :key="code" :value="name">
          {{ name }}
        </option>
      </optgroup>
    </select>
    <div v-if="error" class="formkit-error">{{ error }}</div>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, computed } from "vue";
import countries from "i18n-iso-countries";
import es from "i18n-iso-countries/langs/es.json";

// Registrar el idioma español en i18n-iso-countries
countries.registerLocale(es);

const props = defineProps({
  context: Object,
});

console.log(props.context.node)

// Configurar props y variables reactivas
const selectedCountry = ref("");
const error = ref("");

// Lista de países en español
const countryOptions = ref(countries.getNames("es"));

// Lista de países de Latinoamérica, Centroamérica y España
const latamCountries = [
  "AR",
  "BO",
  "BR",
  "CL",
  "CO",
  "CR",
  "CU",
  "DO",
  "EC",
  "SV",
  "GT",
  "HN",
  "MX",
  "NI",
  "PA",
  "PY",
  "PE",
  "PR",
  "ES",
  "UY",
  "VE",
];

// Ordenar y dividir países en dos grupos
const sortedLatamCountries = computed(() => {
  return Object.entries(countryOptions.value)
    .filter(([code]) => latamCountries.includes(code))
    .sort((a, b) => a[1].localeCompare(b[1]))
    .reduce((acc, [code, name]) => {
      acc[code] = name;
      return acc;
    }, {});
});

const sortedOtherCountries = computed(() => {
  return Object.entries(countryOptions.value)
    .filter(([code]) => !latamCountries.includes(code))
    .sort((a, b) => a[1].localeCompare(b[1]))
    .reduce((acc, [code, name]) => {
      acc[code] = name;
      return acc;
    }, {});
});

// Placeholder y clases de FormKit
const placeholder =
  props.context.node.props.placeholder || "Selecciona tu país";
const classes = props.context.classes;

// Emitir el valor seleccionado al componente FormKit
function emitValue(value) {
  props.context.node.input(value);
  if (value) {
    error.value = "";
  } else {
    error.value = "Debe seleccionar un país válido";
  }
}

// Leer valor inicial de la prop y asignarlo a `selectedCountry`
onMounted(() => {
  selectedCountry.value = props.context.node.value;
});
</script>

<style scoped>
.formkit-input {
  @apply w-full px-2 py-2 mb-1 border border-gray-400 rounded text-xs;
}

.formkit-error {
  @apply text-red-500 text-xs mt-1;
}
</style>
